export default "__VITE_ASSET__d8f2724f__"